/* eslint-disable max-len */
import React, { useContext, useState } from 'react';
import { Box, Grid, Stack, Typography } from '@mui/material';
import { RiAttachment2 } from 'react-icons/ri';
import { LanguageContext } from '../../../libs/Context';
import { formatBytes } from '../../../libs/HelperContent';
import DocViewer from '../../../libs/DocViewer';

const Attachment = (props) =>
{
	const { attachments } = props;
	const { language } = useContext(LanguageContext);
	const [ preview, setPreview ] = useState<any>(false);
	const [ showMoreAttachments, setShowMoreAttachments ] = useState(false);

	const handleToggleAttachments = () =>
	{
		setShowMoreAttachments(!showMoreAttachments);
	};

	const handlePreview = (file) =>
	{
		setPreview(file);
	};

	return (
		<>

			<Grid container direction={'row'} pb='var(--pixel8)' alignItems={'center'} justifyContent={'space-between'}>
				<Grid item py='var(--pixel8)'>
					<Typography fontWeight='var(--font500)' color={'textSecondary'}>{language?.attachments} ({attachments?.length})</Typography>
				</Grid>
				{attachments?.length > 1 &&
				<Grid item>
					<Typography
						fontWeight='var(--font500)'
						color={'var(--primaryColor)'}
						pb='var(--pixel8)'
						variant='body2'
						onClick={handleToggleAttachments}
						style={{ cursor: 'pointer' }}
					>
						{showMoreAttachments ? `${language?.viewless}` : `${language?.viewmore}`}
					</Typography>
				</Grid>}
			</Grid>
			{attachments?.length > 0 &&
			(showMoreAttachments ? attachments : attachments?.slice(0, 1))?.map((attachment, index) => (
				<Grid container direction={'row'} pb='var(--pixel8)' alignItems={'center'} key={index}>
					<Grid item xs={12}>
						<Stack direction={'row'} width={'var(--percent100)'} alignItems={'center'}>
							<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--grayF3)', borderRadius: 'var(--pixel4)', textAlign: 'center', fontWeight: '500', width: 'var(--pixel40)', height: 'var(--pixel40)' }}>
								<RiAttachment2 fontSize='var(--pixel20)'/>
							</Box>
							<Typography
								variant='inherit'
								sx={{
									paddingLeft  : 'var(--pixel4)',
									overflow     : 'hidden',
									textOverflow : 'ellipsis',
									whiteSpace   : 'nowrap',
									maxWidth     : 'calc(100% - 80px)',
									paddingRight : 'var(--pixel4)',
									cursor       : 'pointer',
									'&:hover'    : {
										color  : 'primary.main',
										cursor : 'pointer'
									}
								}}
								onClick={() => handlePreview(attachment)}
							>
								{attachment?.name}
							</Typography>
							<Typography sx={{ paddingLeft: '0.25rem' }} variant='caption' color='textSecondary'>{formatBytes(attachment?.size)}</Typography>
						</Stack>
					</Grid>
				</Grid>
			))}
			{preview?.url &&
				<DocViewer
					closeCallBack={() => { setPreview(false); }}
					url={preview?.url}
					file={preview}
				/>
			}
		</>
	);
};

export default Attachment;
